var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcReply = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.523 6.396c.835-.846 2.268-.246 2.268.956v.81c2.657.482 4.61 1.702 6.003 3.315 1.464 1.697 2.287 3.8 2.695 5.87a.55.55 0 0 1-.311.608.53.53 0 0 1-.649-.182c-1.771-2.514-4.207-3.746-7.738-3.857v.802c0 1.214-1.44 1.786-2.268.948L4.89 11.984a1.36 1.36 0 0 1 0-1.904z",
  clipRule: "evenodd"
})));
export default SvgIcReply;